import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ fullPage }) => (fullPage !== false ? '100vh' : '200px')};
`;

const Ring = styled.div`
  width: 36px;
  height: 36px;
  border: 3px solid ${({ theme }) => theme.colors.border};
  border-top-color: ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
`;

const Spinner = ({ fullPage }) => (
  <Wrapper fullPage={fullPage}>
    <Ring />
  </Wrapper>
);

export default Spinner;
